export default __webpack_public_path__ + "static/media/login-bg-1.c5ce071c.png";